export default {
    methods: {
        createModal(content, params = {}) {
            this.$emit('createModal', content, params);
        }
    }
}
